import {
  FilterType,
  buildTrainingsDataTableFilter,
  useTrainingsDataTable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

export const courseExpirationFilter = (source: ReturnType<typeof useTrainingsDataTable>) => {
  const options = [
    {
      label: i18n.t('trainings.trainings_table.filters.expiration_filter.yes'),
      value: true,
    },
    {
      label: i18n.t('trainings.trainings_table.filters.expiration_filter.no'),
      value: false,
    },
  ]

  return buildTrainingsDataTableFilter(source, {
    type: FilterType.Boolean,
    default: true,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
    identifier: 'courseExpirationFilter',
    path: 'withExpiredMemberships',
    title: i18n.t('trainings.trainings_table.filters.expiration_filter.title'),
    onUpdateValue: () => {
      track(trackingEvents.training.trainingsFilters.retakeFilter)
    },
  })
}
